module.exports = __webpack_public_path__ + "img/jiejuefangan02.da740ea2.png";